<template>
    <div class="app-container">
        <div class="form-shell" v-loading="loadingFlag" >
            <el-form ref="form" :model="form" :rules="rules" label-width="200px">
                <el-form-item prop="sweepstakesPoint" label="抽奖扣除积分">
                    <el-input type="number" v-model.number="form.sweepstakesPoint" placeholder="请输入积分数"></el-input>
                </el-form-item>
                <el-form-item prop="inviteUserPoint" label="邀请用户获得积分">
                    <el-input type="number" v-model.number="form.inviteUserPoint" placeholder="请输入积分数"></el-input>
                </el-form-item>
                <el-form-item prop="passive" label="被邀请用户获得积分">
                    <el-input type="number" v-model.number="form.passive" placeholder="请输入积分数"></el-input>
                </el-form-item>
                 <el-form-item  prop="condition" label="提现门槛">
                    <el-input type="number" v-model.number="form.condition" placeholder="请输入积分数"></el-input>
                </el-form-item>
                <el-form-item label="提现汇率(日元兑换人民币)" prop="rate">
                    <el-input type="number" v-model.number="form.rate" placeholder="请输入提现汇率" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submit" >保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { getSet , modifySet } from '@/api/common.js'
export default {
    data: () => ({
        rules: {
            sweepstakesPoint: [
                { required: true, message: '请输入积分数', trigger: 'blur' },
                {validator:(rule,value,cb)=>{
                    if(value<0)return cb(new Error('请输入大于0的数'))
                    cb()
                },trigger:"change"}
            ],
            inviteUserPoint: [
                { required: true, message: '请输入积分数', trigger: 'blur' },
                 {validator:(rule,value,cb)=>{
                    if(value<0)return cb(new Error('请输入大于0的数'))
                    cb()
                },trigger:"change"}
            ],
            rate: [
                { required: true, message: '请输入积分数', trigger: 'blur' },
                 {validator:(rule,value,cb)=>{
                    if(value<0)return cb(new Error('请输入大于0的数'))
                    cb()
                },trigger:"change"}
            ],
            condition: [
                { required: true, message: '请输入积分数', trigger: 'blur' },
                 {validator:(rule,value,cb)=>{
                    if(value<0)return cb(new Error('请输入大于0的数'))
                    cb()
                },trigger:"change"}
            ],
            passive: [
                { required: true, message: '请输入积分数', trigger: 'blur' },
                 {validator:(rule,value,cb)=>{
                    if(value<0)return cb(new Error('请输入大于0的数'))
                    cb()
                },trigger:"change"}
            ],
        },
        form: {
            sweepstakesPoint: '',
            inviteUserPoint: '',
            rate:'',
            condition:"",
            passive:""
        },
        loadingFlag:false
    }),
    beforeMount(){
        this.getData()
    },
    methods:{
        async getData(){
            try{
                this.loadingFlag=true
                let res=await getSet({
                    prefix:"integral",
                    prefix2:"withdrawal",
                    system_logs_content:"积分管理-积分参数设置-获取",
                    limit:9999
                })
                console.log(res)
                this.form.sweepstakesPoint=res.data.data.find(item=> item.key=="integral.draw.num").value
                this.form.inviteUserPoint=res.data.data.find(item=> item.key=="integral.share").value
                this.form.rate=res.data.data.find(item=> item.key=="withdrawal.rate").value
                this.form.condition=res.data.data.find(item=> item.key=="withdrawal.condition").value
                this.form.passive=res.data.data.find(item=> item.key=="integral.passive.share").value
                this.loadingFlag=false
            }catch(err){
                // this.loadingFlag=false
                console.log('获取失败',err)
            }
        },
        submit(){
            this.$refs["form"].validate(async(flag)=>{
                if(flag){
                    try{
                        this.loadingFlag=true
                        await modifySet({
                            // system_logs_content:"积分管理-积分参数设置-设置",
                            "integral.draw.num":{
                                value:this.form.sweepstakesPoint
                            },
                            "integral.share":{
                                value:this.form.inviteUserPoint
                            },
                            "withdrawal.rate":{
                                value:this.form.rate
                            },
                            "withdrawal.condition":{
                                value:this.form.condition
                            },
                            "integral.passive.share":{
                                value:this.form.passive
                            }
                        })
                        this.$message({
                            message:"修改成功",
                            type:"success"
                        })
                        this.getData()
                    }catch(err){
                        this.loadingFlag=false
                        console.log(err)
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.form-shell {
    max-width: 680px;
}
</style>